import styled from 'styled-components'

const PaymentMethodDetailsUi = styled.div<{ compactLayout?: boolean }>`
  padding: 20px 55px;
  transition: height ease 250ms;
  border-bottom: 1px solid var(--payment-method-border-color);
  &:last-child {
    border-bottom: none;
  }
  ${p => p.theme.phone} {
    padding: 20px;
      ${p => p.compactLayout && 'padding: 20px 10px'}
  }
`

export default PaymentMethodDetailsUi
